import type { AppView } from "../../domain/app-types.ts";

export const dashboardTabLocationKey = "weirdo:tab-location:v1";

const views: ReadonlySet<string> = new Set(["dashboard", "open", "myday", "assigned", "today", "upcoming", "scheduled", "completed", "archived", "conflicts", "trash", "custom", "calendar", "cycle", "backlog"]);

export interface TabLocation {
  savedViewId?: string;
  view: AppView;
  rootId: string | null;
  collectionId: string | null;
}

export function readTabLocation(storage: Pick<Storage, "getItem"> | null): TabLocation | null {
  try {
    const raw = storage?.getItem(dashboardTabLocationKey);
    if (!raw) return null;
    const location = JSON.parse(raw) as Partial<TabLocation>;
    if (!views.has(location.view || "") || location.rootId !== null && typeof location.rootId !== "string" || location.collectionId !== null && typeof location.collectionId !== "string") return null;
    return location as TabLocation;
  } catch { return null; }
}

export function writeTabLocation(storage: Pick<Storage, "setItem"> | null, location: TabLocation): void {
  try { storage?.setItem(dashboardTabLocationKey, JSON.stringify(location)); } catch { /* Private browsing may disable session storage. */ }
}
